module.exports = __webpack_public_path__ + "img/bodyswaps-logo-dark.c857fa2a.png";